import ErrorPage from "./ErrorPage";
import MantaError from "../../../assets/svg/merge-manta-500.svg";

const ErrorFallback = () => (
  <ErrorPage
    illustration={MantaError}
    illustrationAlt="Merge Manta fixing a server with a wrench"
    title="Well, that’s unexpected"
    message="Something went sideways on our end"
    actionLabel="Reload page"
    onAction={() => window.location.reload()}
  />
);

export default ErrorFallback;
